import React from 'react'
import { connect } from 'react-redux'
import { Icon, Menu } from 'semantic-ui-react'

import { sendBillingInvoiceEmail } from 'actions/billing'

class SendBillingInvoiceEmailItem extends React.Component {
  handleClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.props.send(this.props.billingInvoice.id)
  }

  render () {
    const { billingInvoice } = this.props
    if (!['draft', 'issued', 'reminded'].includes(billingInvoice.status)) return null

    const everSent = !!billingInvoice.issuedAt
    return (
      <Menu.Item onClick={this.handleClick} title={everSent ? 'Send reminder' : 'Send invoice'}>
        <Icon name="mail"/>
      </Menu.Item>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  send: (id) => dispatch(sendBillingInvoiceEmail(id))
})

export default connect(null, mapDispatchToProps)(SendBillingInvoiceEmailItem)
